export const environment = {
    production: false,
    clientID: '15',
    apiUrl: 'https://apiv3.plataformaasap.com.br',
    baseUrl: 'https://apiv3.plataformaasap.com.br',
    filestack: {
      key: 'AD5oDjsJaTJOzLe1Llj9mz'
    },
    pusher: {
      key: 'eaf41725f3b027147953',
    },
    firebase: {
      apiKey: "AIzaSyDa8JrO-Cp_4RpY21-xj9GL2z5EQKOCx_M",
      authDomain: "realiza-5088b.firebaseapp.com",
      databaseURL: "https://realiza-5088b.firebaseio.com",
      projectId: "realiza-5088b",
      storageBucket: "realiza-5088b.appspot.com",
      messagingSenderId: "844301755690"
    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts